<template>
  <a
    v-if="article.comments"
    class="flex flex-col w-full rounded-md"
    :class="[firstAppropriateComment && 'border-2 border-[#E2E5E] p-4']"
    :href="articleUrl"
  >
    <div v-if="firstAppropriateComment" class="flex">
      <div class="flex flex-col gap-2">
        <div class="flex items-center">
          <OImage loading="lazy" :src="firstAppropriateComment.user.avatar.resolutions.standard.url" class="mr-2 h-9 w-9 rounded-full" />
          <p class="text-13 font-semibold text-[#424242]">{{ firstAppropriateComment.user.name }}</p>
        </div>
        <p class="text-sm text-[#666] line-clamp-3">{{ firstAppropriateComment.text }}</p>
        <div class="flex items-center mb-4">
          <OIcon icon="heart-comment" svg-class=" w-4 h-4 mr-2" />
          <span class="text-sm text-[#666] leading-22">{{ $t('comment-item.like') }} ({{ firstAppropriateComment.ratings.likes }})</span>
        </div>
      </div>
    </div>
    <div class="flex h-11 pl-[9px] pr-3 items-center rounded-md border-2 border-[#E2E5ED] bg-white">
      <IconMessage width="24px" height="24px" class="text-[#C4C4C4] mr-2.5" />
      <p class="text-[#C4C4C4] text-md font-medium">Sen de yorumunu paylaş! 🙂</p>
    </div>
  </a>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import IconMessage from '~/static/images/messages.svg?inline';
import { OImage, OIcon } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';

export default defineComponent({
  components: { IconMessage, OImage, OIcon },
  props: {},
  setup() {
    const article = inject('article', null);
    const articleUrl = computed(() => getArticleUrl({ article }) + '?sc=true');

    const { isLoggedIn, user } = useAuth();
    const firstAppropriateComment = article.comments?.data?.find((comment) => {
      const isMe = isLoggedIn.value && comment.user?._id === user.value._id;
      return isMe || !comment.isInappropriate;
    });

    return { article, articleUrl, firstAppropriateComment };
  },
});
</script>
